export default import.meta.ROLLDOWN_FILE_URL_krnjt7xns6YRIarnte1sfw